<template> 
    <div class="login-view">
      <transition name="el-zoom-in-center"> 
        <div class="start-login" v-show="startLoginIsShow" @click="startLoginFn"></div>
      </transition>
      <popuView :show="loginPopuIsShow" @close="close">
        <div slot="content" class="login-cont">
          <div class="login-cont-left"> 
            <div class="title">请登录</div>
            <l-input title="账号" placeholder="请输入账号" v-model="form.login.user" margin="0 0 10px 0"/> 
            <l-input type="password" title="密码" placeholder="请输入密码" v-model="form.login.password"/> 
            <div class="btn-view" @click="activeLogin">
              <img src="@/assets/login_button_login_up.png" alt="">
              <img src="@/assets/login_button_login_down.png" alt="">
            </div>
            <div class="woring-info" >
              您的IP地址{{ip}}<br/>不在允许范围内，请登录
            </div>
            <br/>
            <div class="consulting-service">咨询电话：010-66165618 &nbsp; 66126178</div>
          </div>
          <div class="login-cont-right">
            <div class="title">如果您还没有账号，可通过<br/>填写下列信息申请试用账号</div>
            <l-input title="邮箱" placeholder="请输入邮箱" v-model="form.apply.mailbox" margin="0 0 10px 0"/> 
            <l-input title="姓名" placeholder="请输入姓名" v-model="form.apply.name" margin="0 0 10px 0"/> 
            <l-input title="单位" placeholder="请输入单位" v-model="form.apply.company" margin="0 0 10px 0"/> 
            <l-input title="电话" placeholder="请输入电话" v-model="form.apply.telephone" margin="0 0 10px 0"/> 
            <l-input title="密码" placeholder="请输入密码" v-model="form.apply.password" margin="0 0 10px 0"/> 
            <div class="btn-view" @click="activeApply">
              <img src="@/assets/login_button_apply_up.png" alt="">
              <img src="@/assets/login_button_apply_down.png" alt="">
            </div>
          </div>
        </div>
      </popuView>
    </div> 
</template>
<script> 
import popuView from "@/components/popuView.vue"
import lInput from "@/components/l-input.vue"
import { appLogin , appRegister , getUserInfo , getip } from "@/api/lxc/index" 
// import axios from "axios"
export default {
  name: "headerCom", 
  data() {
    return { 
      ip:"",
      loginPopuIsShow:false,
      startLoginIsShow:true,
      form:{
        login:{
          user:"",
          password:""
        },
        apply:{
          mailbox:"",//邮箱
          name:"",//姓名
          company:"",//单位
          telephone:"",//电话
          password:"",//密码
        }
      }
    };
  },
  components:{
    popuView,
    lInput
  },
  computed: {
  }, 
  mounted() {    
    this.getipFn()
  },
  methods: {  
    async getipFn(){
      const {ipAddr} = await getip({})
      console.log(ipAddr)
      this.ip = ipAddr
    },
    //登录
    async appLoginFn(pemail,ppwd){
      const { code , expire , msg , token } = await appLogin({
        pemail,ppwd
      })
      if(code === 0){
        this.$message({  message: '登录成功' });
        this.$router.replace({name:"bookList"})   
        this.$cookies.set('token', token, { expires: expire / 3600.0/24 })
        this.getUser()
      }else{
        this.$message({  message: msg });
      } 
    },
    async getUser(){
      const data = await getUserInfo() 
      this.$store.commit("setUserInfo",data.user) 
    },
    /**
     * @description 点击登录按钮
    */
    activeLogin(){
      const { user , password } =this.form.login
      if(!user){
        this.$message({ 
          message: '请输入账号'
        });
        return
      }
      if(!password){
        this.$message({ 
          message: '请输入密码'
        });
        return
      }

      this.appLoginFn(user , password)
      // this.$router.replace({name:"bookList"})
    },
    //申请账号
    async appRegisterFn(pemail,pname,pphone,ppwd,punits){
      const { code , msg } = await appRegister({
        "pemail": String(pemail),
        "pname":String( pname),
        "pphone": String(pphone),
        "ppwd": String(ppwd),
        "punits": String (punits)
      })

      if(code === 0){
        this.$message({  message: '申请账号成功' });
        this.form.apply={
          mailbox:"",//邮箱
          name:"",//姓名
          company:"",//单位
          telephone:"",//电话
          password:"",//密码
        } 
      }else{
        this.$message({  message: msg });
      }
    },
    /**
     * @description 点击申请账号按钮
     *    mailbox:"",//邮箱
          name:"",//姓名
          Company:"",//单位
          Telephone:"",//电话
          password:"",//密码
    */
    activeApply(){ 
      const { mailbox , name , company ,telephone ,password  } =this.form.apply
      if(!mailbox){
        this.$message({ message: '请输入正确的邮箱' }) 
        return
      }
      if(!name){
        this.$message({ message: '请输入正确的姓名' })
        return
      }
      if(!company){
        this.$message({ message: '请输入正确的单位' })
        return
      }
      // if(!telephone){
      //   this.$message({ message: '请输入正确的电话' })
      //   return
      // }
      if(!password){
        this.$message({ message: '请输入正确的密码' })
        return
      }

      this.appRegisterFn(mailbox , name , telephone , password , company)
    },
    startLoginFn(){
      console.log(222)
      this.startLoginIsShow=false
      this.loginPopuIsShow=true
    },
    close(){
      console.log(11)
      this.loginPopuIsShow=false
      this.startLoginIsShow=true
    },
    // secondToDate(msd) {
    //         var time =msd
    //         if (null != time && "" != time) {
    //             if (time > 60 && time < 60 * 60) {
    //                 time = parseInt(time / 60.0) + "分钟" + parseInt((parseFloat(time / 60.0) -
    //                     parseInt(time / 60.0)) * 60) + "秒";
    //             }
    //             else if (time >= 60 * 60 && time < 60 * 60 * 24) {
    //                 time = parseInt(time / 3600.0) + "小时" + parseInt((parseFloat(time / 3600.0) -
    //                     parseInt(time / 3600.0)) * 60) + "分钟" +
    //                     parseInt((parseFloat((parseFloat(time / 3600.0) - parseInt(time / 3600.0)) * 60) -
    //                     parseInt((parseFloat(time / 3600.0) - parseInt(time / 3600.0)) * 60)) * 60) + "秒";
    //             } else if (time >= 60 * 60 * 24) {
    //                 time = parseInt(time / 3600.0/24) + "天" +parseInt((parseFloat(time / 3600.0/24)-
    //                     parseInt(time / 3600.0/24))*24) + "小时" + parseInt((parseFloat(time / 3600.0) -
    //                     parseInt(time / 3600.0)) * 60) + "分钟" +
    //                     parseInt((parseFloat((parseFloat(time / 3600.0) - parseInt(time / 3600.0)) * 60) -
    //                     parseInt((parseFloat(time / 3600.0) - parseInt(time / 3600.0)) * 60)) * 60) + "秒";
    //             }
    //             else {
    //                 time = parseInt(time) + "秒";
    //             }
    //         }
    //         return time;
    //     }
  }
};
</script>
<style scoped lang="less">
.login-cont{
  display: flex;
  justify-content: space-between;
  color: #3a3a3a;

  &-left{
    width: 50%;
    padding: 10px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;

    .title{
      font-size: 16px;
      font-weight: 600;
      padding: 50px 0 20px 0;
    }

    .btn-view{
      margin: 20px 0 0 0;
    }

    .woring-info{
      color: red;
      padding: 16px 0 0 0;
    }
  }

  &-right{
    width: 50%;
    padding: 10px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;

    .title{
      padding: 10px 0 16px 0;
    }

  }
}

.btn-view{
  position: relative;
  width: 190px;
  height: 32px;
  cursor: pointer;
  left: 10px;

  img{
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;

    &:nth-child(1){
      z-index: 3;

      &:hover{
        z-index: 1;
      }
    }
    &:nth-child(2){
      z-index: 2;

      &:hover{
        z-index: 4;
      }
    }
  }
}
.login-view{
    position: absolute;
    top: 0;
    left: 0;
    // z-index: 99;
    width: 100%;
    height: 100%;
    background-image: url(../../assets/bg_.jpg);
    display: flex;
    align-items: center;
    justify-content: center;

    .start-login{
      // max-width: 1920px;
      width: 100%;
      height: 100%;
      background-image: url(../../assets/loginbg.jpg);
      background-size:cover ;
      background-position: center;
      cursor: pointer;
    }
}


</style>
